const uid = () => (window.crypto?.randomUUID ? window.crypto.randomUUID().replace(/-/g, "").slice(0, 12) : Math.random().toString(36).slice(2, 14));

export const trackKey = (t) => (t.source === "spotify" ? t.uri : t.source === "youtube" ? `yt:${t.video_id}` : `file:${t.url}`);

export const newTrack = (t) => ({ ...t, id: uid() });

export const fileTrack = (url, filename) => newTrack({
  source: "file", url, title: filename.replace(/\.[^.]+$/, "").replace(/[_-]+/g, " ").trim(), artist: "", cover: "", duration_ms: 0,
  uri: "", preview_url: "", video_id: "", match_title: "",
});

const CHIP = {
  spotify: ["SPOTIFY", "text-[#1ED760] border-[#1ED760]/50"],
  youtube: ["YT MUSIC", "text-[#FF2A55] border-[#FF2A55]/50"],
  file: ["MY FILE", "text-[#00F0FF] border-[#00F0FF]/50"],
};

export const SourceChip = ({ t }) => {
  const [label, cls] = CHIP[t?.source] || CHIP.file;
  return <span className={`shrink-0 border font-mono text-[9px] font-bold tracking-[0.2em] px-1.5 py-0.5 ${cls}`}>{label}</span>;
};
